import type { ExternoResponse, ResumoExternosResponse, SalvarExternosDto } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Entidades com codigos externos (GET/PUT /externos/:entidade/:id). */
export type EntidadeExterna = 'centros-custo' | 'contas-contabeis' | 'clientes' | 'itens' | 'imobilizados' | 'pessoas';

/** Codigos externos de um cadastro (GET /externos/:entidade/:id). `importado` vem da importacao (somente leitura). */
export function useExternos(entidade: EntidadeExterna, id: string | undefined) {
  return useConsulta<ExternoResponse[]>(['externos', entidade, id], `/externos/${entidade}/${id}`, { ativo: !!id });
}

/** Aba Integracoes (GET /externos/resumo): so a contagem de codigos por sistema e tipo de cadastro. Os codigos se editam em cada cadastro. */
export function useResumoExternos() {
  return useConsulta<ResumoExternosResponse>(['externos', 'resumo'], '/externos/resumo');
}

/** Grava os codigos NAO importados do cadastro (PUT /externos/:entidade/:id). Erros 422 (EXTERNO_EM_USO, EXTERNO_DUPLICADO) vem com a mensagem da API. */
export function useSalvarExternos() {
  return useMutacao<ExternoResponse[], { entidade: EntidadeExterna; id: string; dto: SalvarExternosDto }>({
    metodo: 'PUT',
    caminho: (v) => `/externos/${v.entidade}/${v.id}`,
    corpo: (v) => v.dto,
    invalidar: [['externos']],
  });
}
